<template>
    <span
        :class="['inline-flex items-center rounded-full px-2 py-1 text-xs font-semibold ring-1 ring-inset', badgeTypes[type]]">
        <slot />
    </span>
</template>

<script setup lang="ts">
defineProps({
    type: {
        type: String as PropType<keyof typeof badgeTypes>,
        default: 'primary'
    },
    customStyle: {
        type: String,
        default: null,
    }
})

const badgeTypes = {
    primary: 'bg-primary-50 dark:bg-primary-600/10 text-primary-700 dark:text-primary-200 ring-primary-600/10 dark:ring-primary-400/10',
    secondary: 'bg-gray-50 dark:bg-gray-600/10 text-gray-700 dark:text-gray-200 ring-gray-600/10 dark:ring-gray-400/10',
    success: 'bg-success-50 dark:bg-success-600/10 text-success-700 dark:text-success-200 ring-success-600/10 dark:ring-success-400/10',
    warning: 'bg-warning-50 dark:bg-warning-600/10 text-warning-700 dark:text-warning-200 ring-warning-600/10 dark:ring-warning-400/10',
    danger: 'bg-red-50 dark:bg-red-600/10 text-red-700 dark:text-red-200 ring-red-600/10 dark:ring-red-400/10',
}
</script>

